import i18next from "i18next";
import i18nextHttpBackend, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { transform } from "./transform";
import { Form, Initializer, Payload } from "../types";
import { Json } from "../utils";
import { Fallback } from "../resources";

export const initializer: Initializer = ({ language, resolve }) => {
  const i18n = i18next.createInstance();

  i18n
    .use(i18nextHttpBackend)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
      lng: language,
      fallbackLng: "nl",
      supportedLngs: ["nl", "en"],
      ns: "all-forms",
      defaultNS: "all-forms",
      fallbackNS: "all-forms",
      returnEmptyString: false,
      returnObjects: true,
      ignoreJSONStructure: true,
      interpolation: {
        escapeValue: false
      },
      backend: {
        parse: (data) => {
          const json = JSON.parse(data) as Form;
          const transformed = transform(json);

          return Json.nest(transformed);
        },
        parseLoadPayload: (languages, namespaces): Payload => ({
          language: languages[0],
          namespace: namespaces[0]
        }),
        request: async (options, url, payload: Payload, callback) => {
          resolve(payload.namespace, payload.language)
            .then((response) => callback(null, { status: 200, data: JSON.stringify(response) }))
            .catch((error) => callback(error, null));
        }
      }
    });

  // Add fallback resources just in case something goes wrong
  i18n.addResourceBundle("nl", Fallback.namespace, Fallback.nl);
  i18n.addResourceBundle("en", Fallback.namespace, Fallback.en);

  return i18n;
};
